import { SpinnerLegacy } from "../../../../../components";
import { useSellarUser } from "../../../../../hooks";
import { useUserNotificationPreference } from "../../../../../hooks/api/v2/userNotificationPreference/useUserNotificationPreference";
import { OptInMarketingForm } from "./OptInMarketingForm";

export const UserSettingsUpdateMarketingPreferencesDialogContent = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => {
  const { user } = useSellarUser();
  const userNotificationPreferencesId = user?.UserNotificationPreferenceId;
  const userNotificationPreferenceQuery = useUserNotificationPreference(
    userNotificationPreferencesId ?? 0,
    {
      enabled: !!userNotificationPreferencesId,
    },
  );

  if (userNotificationPreferenceQuery.isPending) return <SpinnerLegacy />;

  if (!userNotificationPreferenceQuery.data) return null;

  return (
    <OptInMarketingForm
      UserNotificationPreferences={userNotificationPreferenceQuery.data}
      onDismiss={onDismiss}
    />
  );
};
